var deprecatedProperties = {
  loading: "The 'loading' prop is deprecated. Use 'isLoading' instead."
};

export { deprecatedProperties };
